import React, { createContext, useState, useEffect } from 'react';

const PageContext = createContext();

const PageProvider = (props) => {
    const [reviewData, setReviewData] = useState({
        course: {},
        instructors: [],
        students: [],
    });

    useEffect(() => {}, []);

    return <PageContext.Provider value={{ reviewData, setReviewData }} {...props} />;
};

export { PageContext };
export default PageProvider;
